import { string } from 'prop-types';

export default {
    hex: string
};
